import { Box, styled, Text } from '@ltvco/refresh-lib/theme';

export const NameSection = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 16,
  marginBottom: 16,
});

export const PhotoContainer = styled(Box)(({ theme }) => ({
  width: 72,
  height: 72,
  borderRadius: '50%',
  backgroundColor: theme.palette.grey[300],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  overflow: 'hidden',
  fontSize: 11,
  fontWeight: 600,
  color: theme.palette.text.secondary,
}));

export const NameInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  paddingTop: 4,
});

export const DateLine = styled(Text)(({ theme }) => ({
  color: theme.palette.text.secondary,
  display: 'block',
}));

export const LocationText = styled(Text)(({ theme }) => ({
  color: theme.palette.text.secondary,
  display: 'block',
}));

export const LinkText = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'none',
  cursor: 'pointer',
  fontSize: 14,
  background: 'none',
  border: 'none',
  padding: 0,
  font: 'inherit',
  textAlign: 'left',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const MessageText = styled(Text)(({ theme }) => ({
  color: theme.palette.text.primary,
  display: 'block',
  lineHeight: 1.6,
  marginBottom: 8,
  whiteSpace: 'pre-line',
}));
